import { Button } from '@st/theme'
import { match, P } from '@st/pattern'
import { ClientCard, ClientCardStepHeading } from './ui'

/** Dashboard step for the firm's invoice. Paying happens on the firm's site; the client reports it here. */
export function ClientPayInvoiceCard({
  stepNumber,
  paidLabel,
  archived,
  onSetStatus,
  onPay
}: {
  stepNumber: number
  paidLabel: string | undefined
  archived: boolean
  onSetStatus: (status: 'paid' | 'unpaid') => void
  onPay: () => void
}) {
  return (
    <ClientCard>
      <ClientCardStepHeading
        stepNumber={stepNumber}
        completed={paidLabel != undefined}
        title={<h2 className="text-xl font-semibold text-gray-900">View invoice</h2>}
        status={match(paidLabel)
          .with(P.string, (label) => <span className="text-base leading-6">{label}</span>)
          .otherwise(() => (
            <span className="text-base leading-6">
              Pay your invoice, then let us know you&apos;ve paid.
            </span>
          ))}
        action={match(paidLabel)
          .with(P.string, () => (
            <Button variant="link" disabled={archived} onClick={() => onSetStatus('unpaid')}>
              Mark unpaid
            </Button>
          ))
          .otherwise(() => (
            <div className="flex gap-2">
              <Button
                variant="default"
                size="l"
                disabled={archived}
                onClick={() => onSetStatus('paid')}
              >
                I&apos;ve paid
              </Button>
              <Button variant="primary" size="l" onClick={onPay}>
                View invoice
              </Button>
            </div>
          ))}
      />
    </ClientCard>
  )
}
